import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface WishlistItem {
  id: number | string;
  name: string;
  price: string;
  image: string;
  addedAt: number;
}

interface WishlistState {
  items: WishlistItem[];
  hydrated: boolean;
  hydrate: () => void;
  addItem: (item: WishlistItem) => void;
  removeItem: (id: number | string) => void;
  isWishlisted: (id: number | string) => boolean;
  clearWishlist: () => void;
}

export const useWishlistStore = create<WishlistState>()(
  persist(
    (set, get) => ({
      items: [],
      hydrated: false,
      hydrate: () => set({ hydrated: true }),
      addItem: (item) =>
        set((state) => ({
          items: state.items.some((i) => i.id === item.id)
            ? state.items
            : [...state.items, { ...item, addedAt: item.addedAt || Date.now() }],
        })),
      removeItem: (id) =>
        set((state) => ({
          items: state.items.filter((i) => i.id !== id),
        })),
      isWishlisted: (id) => get().items.some((i) => i.id === id),
      clearWishlist: () => set({ items: [] }),
    }),
    {
      name: 'wishlist-storage',
      partialize: (state) => ({ items: state.items }),
      onRehydrateStorage: () => (state) => {
        if (state) state.hydrate();
      },
    }
  )
);
